(function (root) {
  'use strict';

  var FREQUENCY = { daily: 20, weekly: 4, biweekly: 2, monthly: 1 };
  var LABELS = {
    'Sell Most': { text: 'Sell Most', status: 'most' },
    'Sell Less': { text: 'Sell Less', status: 'less' },
    'Not Permitted': { text: 'Not Permitted', status: 'fail' },
    'Needs Review': { text: 'Needs nutrition data', status: 'review' }
  };

  function number(profile, key) {
    var value = profile && profile[key];
    if (value === '' || value === null || typeof value === 'undefined') return null;
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function truth(profile, key) {
    var value = profile && profile[key];
    if (value === true || value === 'true' || value === 'Yes' || value === 'yes') return true;
    if (value === false || value === 'false' || value === 'No' || value === 'no') return false;
    return null;
  }

  function result(classification, missing, detail) {
    return { classification: classification, missing: missing || [], detail: detail || '' };
  }

  function requireValues(profile, keys) {
    return keys.filter(function (key) {
      var value = profile && profile[key];
      return value === '' || value === null || typeof value === 'undefined';
    });
  }

  function scaleProfile(profile, factor) {
    if (!profile || !Object.keys(profile).length || factor === 1) return profile;
    var scaled = Object.assign({}, profile);
    ['calories', 'fat', 'saturated_fat', 'trans_fat', 'sodium', 'carbohydrate', 'fibre', 'sugars', 'protein', 'calcium_dv', 'container_ml'].forEach(function (key) {
      var value = number(profile, key);
      if (value !== null) scaled[key] = value * factor;
    });
    return scaled;
  }

  function classifyBalanced(profile, schoolLevel) {
    var full = classify(profile, schoolLevel);
    var half = classify(scaleProfile(profile, 0.5), schoolLevel);
    var rank = { 'Not Permitted': 0, 'Needs Review': 1, 'Sell Less': 2, 'Sell Most': 3 };
    return (rank[half.classification] || 0) > (rank[full.classification] || 0) ? half : full;
  }

  function classify(profile, schoolLevel) {
    profile = profile || {};
    var manual = profile.manual_classification || profile.classification;
    if (manual === 'Sell Most' || manual === 'Sell Less' || manual === 'Not Permitted') {
      return result(manual, [], 'Classification supplied with the nutrition profile.');
    }

    var category = profile.category || '';
    if (!category) return result('Needs Review', ['category'], 'Add a PPM 150 category.');

    var fat = number(profile, 'fat');
    var sat = number(profile, 'saturated_fat');
    var sodium = number(profile, 'sodium');
    var fibre = number(profile, 'fibre');
    var protein = number(profile, 'protein');
    var calories = number(profile, 'calories');
    var sugars = number(profile, 'sugars');
    var calcium = number(profile, 'calcium_dv');
    var fatMf = number(profile, 'fat_mf');
    var container = number(profile, 'container_ml');
    var wholeGrain = truth(profile, 'whole_grain_first');
    var fruitVeg = truth(profile, 'fruit_veg_first');
    var sugarFirst = truth(profile, 'sugar_first');
    var juice100 = truth(profile, 'juice_100');
    var fortified = truth(profile, 'fortified_ca_d');
    var caffeine = truth(profile, 'caffeine');
    var coated = truth(profile, 'coated');
    var plain = truth(profile, 'plain');
    var missing;

    if (category === 'Vegetables & Fruit - Fresh/Frozen/Canned/Dried') {
      missing = requireValues(profile, ['fruit_veg_first', 'fat', 'sodium', 'sugar_first']);
      if (missing.length) return result('Needs Review', missing);
      if (fruitVeg && !sugarFirst && fat <= 3 && sodium <= 360) return result('Sell Most');
      missing = requireValues(profile, ['saturated_fat']);
      if (missing.length) return result('Needs Review', missing);
      if (fruitVeg && !sugarFirst && fat <= 5 && sat <= 2 && sodium <= 480) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Vegetables & Fruit - Canned Tomato/Tomato Product') {
      missing = requireValues(profile, ['fat', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      return result(fat <= 3 && sodium <= 480 ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Vegetables & Fruit - Chips') {
      missing = requireValues(profile, ['fat', 'saturated_fat', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 3 && sodium <= 240) return result('Sell Most');
      if (fat <= 5 && sat <= 2 && sodium <= 480) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Grain - Bread') {
      missing = requireValues(profile, ['whole_grain_first', 'saturated_fat', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      if (wholeGrain) {
        if (fibre === null) return result('Needs Review', ['fibre']);
        if (sat <= 2 && sodium <= 240 && fibre >= 2) return result('Sell Most');
      }
      return result(sat <= 2 && sodium <= 480 ? 'Sell Less' : 'Not Permitted');
    }
    if (category === 'Grain - Pasta/Rice/Other Grains' || category === 'Grain - Grain-based Snacks') {
      missing = requireValues(profile, ['fat', 'saturated_fat', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 3 && sat <= 2 && sodium <= 240) return result('Sell Most');
      if (fat <= 5 && sat <= 2 && sodium <= 480) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Grain - Baked Goods') {
      missing = requireValues(profile, ['fat', 'saturated_fat', 'fibre']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 5 && sat <= 2 && fibre >= 2) return result('Sell Most');
      if (fat <= 10 && sat <= 2 && fibre >= 2) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Grain - Cereals') {
      missing = requireValues(profile, ['whole_grain_first', 'saturated_fat', 'fibre']);
      if (missing.length) return result('Needs Review', missing);
      return result(wholeGrain && sat <= 2 && fibre >= 2 ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Milk & Alternatives - Yogurt/Kefir') {
      if (fatMf === null && fat === null) return result('Needs Review', ['fat_mf or fat']);
      return result((fatMf !== null && fatMf <= 3.25) || (fat !== null && fat <= 3) ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Milk & Alternatives - Cheese') {
      missing = requireValues(profile, ['fat_mf', 'sodium', 'calcium_dv']);
      if (missing.length) return result('Needs Review', missing);
      if (fatMf <= 20 && sodium <= 360 && calcium >= 15) return result('Sell Most');
      if (sodium <= 480 && calcium >= 15) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Milk & Alternatives - Milk-based Desserts') {
      missing = requireValues(profile, ['fat', 'sodium', 'calcium_dv']);
      if (missing.length) return result('Needs Review', missing);
      return result(fat <= 5 && sodium <= 360 && calcium >= 5 ? 'Sell Less' : 'Not Permitted');
    }
    if (category === 'Meat & Alternatives - Fresh/Frozen Meat') {
      missing = requireValues(profile, ['fat', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 10 && sodium <= 480) return result('Sell Most');
      if (fat <= 14 && sodium <= 480) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Meat & Alternatives - Deli Meat') {
      missing = requireValues(profile, ['fat', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 5 && sodium <= 480) return result('Sell Most');
      if (fat <= 5 && sodium <= 600) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Meat & Alternatives - Fish') {
      missing = requireValues(profile, ['fat', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 8 && sodium <= 480) return result('Sell Most');
      if (fat <= 12 && sodium <= 480) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Meat & Alternatives - Eggs') {
      missing = requireValues(profile, ['fat', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      return result(fat <= 7 && sodium <= 480 ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Meat & Alternatives - Nuts/Protein Butters/Seeds') {
      missing = requireValues(profile, ['coated', 'sodium']);
      if (missing.length) return result('Needs Review', missing);
      return result(!coated && sodium <= 480 ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Meat & Alternatives - Meat Alternatives') {
      missing = requireValues(profile, ['fat', 'sodium', 'protein']);
      if (missing.length) return result('Needs Review', missing);
      return result(fat <= 8 && sodium <= 480 && protein >= 10 ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Mixed Dish - Entree (Nutrition Facts)') {
      missing = requireValues(profile, ['fat', 'saturated_fat', 'sodium', 'fibre', 'protein']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 10 && sat <= 5 && sodium <= 960 && fibre >= 2 && protein >= 10) return result('Sell Most');
      if (fat <= 15 && sat <= 7 && sodium <= 960 && fibre >= 2 && protein >= 7) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Mixed Dish - Soup (Nutrition Facts)') {
      missing = requireValues(profile, ['fat', 'saturated_fat', 'sodium', 'fibre']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 3 && sodium <= 720 && fibre >= 2) return result('Sell Most');
      if (fat <= 5 && sat <= 2 && sodium <= 720) return result('Sell Less');
      return result('Not Permitted');
    }
    if (category === 'Mixed Dish - Side Dish (Nutrition Facts)') {
      missing = requireValues(profile, ['fat', 'saturated_fat', 'sodium', 'fibre']);
      if (missing.length) return result('Needs Review', missing);
      if (fat <= 5 && sat <= 2 && sodium <= 360 && fibre >= 2) return result('Sell Most');
      if (fat <= 7 && sat <= 2 && sodium <= 360) return result('Sell Less');
      return result('Not Permitted');
    }
    if (/^Mixed Dish - .+ \(No Nutrition Facts\)$/.test(category)) {
      var ingredients = profile.major_ingredients_status;
      if (ingredients === 'Sell Most' || ingredients === 'Sell Less' || ingredients === 'Not Permitted') return result(ingredients);
      return result('Needs Review', ['major_ingredients_status']);
    }
    if (category === 'Beverage - Water') {
      if (plain === null) return result('Needs Review', ['plain']);
      return result(plain ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Beverage - Milk/Milk-based' || category === 'Beverage - Hot Chocolate') {
      missing = requireValues(profile, ['sugars', 'calcium_dv']);
      if (fatMf === null && fat === null) missing.push('fat_mf or fat');
      if (schoolLevel === 'Elementary' && container === null) missing.push('container_ml');
      if (missing.length) return result('Needs Review', missing);
      var milkFatOk = (fatMf !== null && fatMf <= 2) || (fat !== null && fat <= 5);
      return result(milkFatOk && sugars <= 28 && calcium >= 25 && (schoolLevel !== 'Elementary' || container <= 250) ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Beverage - Yogurt Drink') {
      if (fatMf === null && fat === null) return result('Needs Review', ['fat_mf or fat']);
      if (schoolLevel === 'Elementary' && container === null) return result('Needs Review', ['container_ml']);
      var yogurtFatOk = (fatMf !== null && fatMf <= 3.25) || (fat !== null && fat <= 3);
      return result(yogurtFatOk && (schoolLevel !== 'Elementary' || container <= 250) ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Beverage - Soy/Milk Alternative') {
      if (fortified === null) return result('Needs Review', ['fortified_ca_d']);
      if (schoolLevel === 'Elementary' && container === null) return result('Needs Review', ['container_ml']);
      return result(fortified && (schoolLevel !== 'Elementary' || container <= 250) ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Beverage - 100% Vegetable/Fruit Juice') {
      missing = requireValues(profile, ['juice_100', 'sugar_first']);
      if (schoolLevel === 'Elementary' && container === null) missing.push('container_ml');
      if (missing.length) return result('Needs Review', missing);
      return result(juice100 && !sugarFirst && (schoolLevel !== 'Elementary' || container <= 250) ? 'Sell Most' : 'Not Permitted');
    }
    if (category === 'Beverage - Coffee/Tea') {
      if (schoolLevel === 'Elementary') return result('Not Permitted');
      if (caffeine === null) return result('Needs Review', ['caffeine']);
      return result(caffeine ? 'Not Permitted' : 'Sell Less');
    }
    if (category === 'Beverage - Iced Tea') {
      if (schoolLevel === 'Elementary') return result('Not Permitted');
      missing = requireValues(profile, ['calories', 'caffeine']);
      if (missing.length) return result('Needs Review', missing);
      return result(calories <= 40 && !caffeine ? 'Sell Less' : 'Not Permitted');
    }
    if (category === 'Beverage - Energy Drink' || category === 'Beverage - Sports Drink') return result('Not Permitted');
    if (category === 'Beverage - Other') {
      if (schoolLevel === 'Elementary') return result('Not Permitted');
      missing = requireValues(profile, ['calories', 'caffeine']);
      if (missing.length) return result('Needs Review', missing);
      return result(calories <= 40 && !caffeine ? 'Sell Less' : 'Not Permitted');
    }
    if (category === 'Miscellaneous - Confectionery') return result('Not Permitted');
    return result('Needs Review', ['manual_classification'], 'This category needs a manual classification.');
  }

  function choiceType(profile) {
    return profile && /^Beverage -/.test(profile.category || '') ? 'Beverage' : 'Food';
  }

  function summarize(items) {
    var summary = {
      Food: { most: 0, less: 0, notPermitted: 0, review: 0, total: 0 },
      Beverage: { most: 0, less: 0, notPermitted: 0, review: 0, total: 0 }
    };
    items.forEach(function (item) {
      var bucket = summary[item.type];
      var weight = item.weight;
      bucket.total += weight;
      if (item.classification === 'Sell Most') bucket.most += weight;
      else if (item.classification === 'Sell Less') bucket.less += weight;
      else if (item.classification === 'Not Permitted') bucket.notPermitted += weight;
      else bucket.review += weight;
    });
    Object.keys(summary).forEach(function (key) {
      var bucket = summary[key];
      bucket.percent = bucket.total ? bucket.most / bucket.total : 0;
      bucket.addMost = Math.max(0, (4 * bucket.less) - bucket.most);
      if (!bucket.total) bucket.status = 'empty';
      else if (bucket.notPermitted) bucket.status = 'fail';
      else if (bucket.review) bucket.status = 'review';
      else if (bucket.percent >= 0.8 && bucket.less / bucket.total <= 0.2) bucket.status = 'pass';
      else bucket.status = 'fail';
    });
    return summary;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function optionList(items, selected, placeholder) {
    var html = '<option value="">' + escapeHtml(placeholder) + '</option>';
    items.forEach(function (item) {
      html += '<option value="' + escapeHtml(item.id) + '"' + (String(item.id) === String(selected) ? ' selected' : '') + '>' + escapeHtml(item.title) + '</option>';
    });
    return html;
  }

  function cleanMenuTitle(productTitle, variantTitle) {
    var title = String(variantTitle || '').trim()
      .replace(/\s*(?:\/|-|–)\s*\$?\d+(?:\.\d{1,2})?\s*$/, '')
      .replace(/\s*\(\$?\d+(?:\.\d{1,2})?\)\s*$/, '')
      .trim();
    if (/^Milk\b/i.test(productTitle || '') && /^[A-Za-z]+\s*\/\s*(?:Monday|Tuesday|Wednesday|Thursday|Friday)s?$/i.test(title)) {
      return productTitle;
    }
    return title || productTitle || 'Menu item';
  }

  function groupMenuItems(product) {
    var grouped = {};
    (product.variants || []).forEach(function (variant) {
      var title = cleanMenuTitle(product.title, variant.title);
      var key = title.toLowerCase().replace(/\s+/g, ' ').trim();
      if (!grouped[key]) grouped[key] = { id: String(variant.id), title: title, variants: [] };
      grouped[key].variants.push(variant);
    });
    return Object.keys(grouped).map(function (key) { return grouped[key]; });
  }

  function groupItemSections(items) {
    if (!items || items.length < 6) return [{ key: 'all', title: 'Menu items', entries: items.map(function (item) { return { item: item, label: item.title }; }) }];

    var splitItems = items.map(function (item) {
      return { item: item, parts: item.title.split(' / ').map(function (part) { return part.trim(); }) };
    });
    if (splitItems.every(function (entry) { return entry.parts.length >= 2; })) {
      var firstCount = new Set(splitItems.map(function (entry) { return entry.parts[0].toLowerCase(); })).size;
      var lastCount = new Set(splitItems.map(function (entry) { return entry.parts[entry.parts.length - 1].toLowerCase(); })).size;
      var useFirst = firstCount <= lastCount;
      var groupCount = useFirst ? firstCount : lastCount;
      if (groupCount > 1 && groupCount < items.length) {
        var slashGroups = {};
        splitItems.forEach(function (entry) {
          var sectionTitle = useFirst ? entry.parts.shift() : entry.parts.pop();
          var key = sectionTitle.toLowerCase();
          if (!slashGroups[key]) slashGroups[key] = { key: key, title: sectionTitle, entries: [] };
          slashGroups[key].entries.push({ item: entry.item, label: entry.parts.join(' / ') });
        });
        return Object.keys(slashGroups).map(function (key) { return slashGroups[key]; });
      }
    }

    var prefixGroups = {};
    items.forEach(function (item) {
      var size = item.title.match(/^(Gluten Free\s+)?(4|6|8|12|24)\s*(inch|oz)\b/i);
      var adult = item.title.match(/^Adult\s*-\s*/i);
      var sectionTitle = size ? size[0].replace(/\s+/g, ' ').trim() : adult ? 'Adult menu' : 'Other options';
      var label = size ? item.title.slice(size[0].length).trim() : adult ? item.title.replace(/^Adult\s*-\s*/i, '') : item.title;
      var key = sectionTitle.toLowerCase();
      if (!prefixGroups[key]) prefixGroups[key] = { key: key, title: sectionTitle, entries: [] };
      prefixGroups[key].entries.push({ item: item, label: label || item.title });
    });
    if (Object.keys(prefixGroups).length > 1) return Object.keys(prefixGroups).map(function (key) { return prefixGroups[key]; });
    return [{ key: 'all', title: 'Menu items', entries: items.map(function (item) { return { item: item, label: item.title }; }) }];
  }

  function initBuilder(element) {
    var productsNode = element.querySelector('[data-ppm-products]');
    var products;
    try { products = JSON.parse(productsNode.textContent || '[]'); }
    catch (error) {
      element.querySelector('.byl-ppm__layout').insertAdjacentHTML('beforebegin', '<div class="byl-ppm__fatal">The product list could not be loaded.</div>');
      return;
    }

    products = products.filter(function (product) { return product.variants && product.variants.length; });
    products.forEach(function (product) {
      product.menuItems = groupMenuItems(product).filter(function (item) {
        return !/\badult\b/i.test(item.title) && !/^24oz\s*\//i.test(item.title);
      });
    });
    var fallback = {};
    var activeBrands = {};
    var choices = {};
    var brandSelect = element.querySelector('[data-ppm-brand-select]');
    var brandFrequency = element.querySelector('[data-ppm-brand-frequency]');
    var brandAdd = element.querySelector('[data-ppm-brand-add]');
    var groupsNode = element.querySelector('[data-ppm-groups]');
    var schoolNode = element.querySelector('[data-ppm-school-level]');
    var balancedNode = element.querySelector('[data-ppm-balanced-day]');

    function findProduct(id) { return products.find(function (product) { return String(product.id) === String(id); }); }
    function findMenuItem(product, id) { return product && product.menuItems.find(function (item) { return String(item.id) === String(id); }); }
    function profileFor(variant) {
      if (!variant) return null;
      var external = fallback[String(variant.id)] || {};
      return Object.assign({}, external, variant.profile || {});
    }

    function profileForItem(item) {
      if (!item || !item.variants) return null;
      var first = null;
      for (var index = 0; index < item.variants.length; index += 1) {
        var profile = profileFor(item.variants[index]);
        if (!first) first = profile;
        if (profile && Object.keys(profile).length) return profile;
      }
      return first;
    }

    function assessmentProfileForItem(item) {
      return scaleProfile(profileForItem(item), balancedNode && balancedNode.checked ? 0.5 : 1);
    }

    function classificationForItem(item) {
      var profile = profileForItem(item);
      return balancedNode && balancedNode.checked ? classifyBalanced(profile, schoolNode.value) : classify(profile, schoolNode.value);
    }

    function productVisual(product) {
      return product.image
        ? '<img src="' + escapeHtml(product.image) + '" alt="" loading="lazy">'
        : '<span aria-hidden="true">' + escapeHtml(product.title.charAt(0)) + '</span>';
    }

    function chevron(expanded) {
      return '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + (expanded ? 'm5 12.5 5-5 5 5' : 'm5 7.5 5 5 5-5') + '"/></svg>';
    }

    function frequencyOptions(selected) {
      return '<option value="daily"' + (selected === 'daily' ? ' selected' : '') + '>Daily (20×)</option>' +
        '<option value="weekly"' + (selected === 'weekly' ? ' selected' : '') + '>Weekly (4×)</option>' +
        '<option value="biweekly"' + (selected === 'biweekly' ? ' selected' : '') + '>Bi-weekly (2×)</option>' +
        '<option value="monthly"' + (selected === 'monthly' ? ' selected' : '') + '>Monthly (1×)</option>';
    }

    function renderBrands() {
      var available = products.filter(function (product) { return !activeBrands[String(product.id)]; });
      brandSelect.innerHTML = '<option value="">' + (available.length ? 'Choose a brand' : 'All brands added') + '</option>' + available.map(function (product) {
        return '<option value="' + escapeHtml(product.id) + '">' + escapeHtml(product.title) + '</option>';
      }).join('');
      brandSelect.disabled = !available.length;
      brandAdd.disabled = !available.length || !brandSelect.value;
    }

    function optionDetails(profile, classification) {
      if (classification.missing.length) return 'Nutrition needed: ' + classification.missing.join(', ').replaceAll('_', ' ');
      if (profile && profile.verification_status === 'sample') return profile.notes || 'Sample nutrition data—verify before use.';
      if (profile && profile.last_verified) return 'Verified ' + profile.last_verified + '.';
      return (profile && profile.category) || classification.detail || 'Nutrition profile loaded.';
    }

    function renderGroups() {
      var selectedProducts = products.filter(function (product) { return !!activeBrands[String(product.id)]; });
      if (!selectedProducts.length) {
        groupsNode.innerHTML = '<div class="byl-ppm__empty"><strong>Choose a brand above</strong><span>Its complete menu option list will appear here.</span></div>';
        updateResults();
        return;
      }

      groupsNode.innerHTML = selectedProducts.map(function (product) {
        var brandConfig = activeBrands[String(product.id)];
        brandConfig.sectionState = brandConfig.sectionState || {};
        var productChoices = choices[String(product.id)] || {};
        var selectedCount = Object.keys(productChoices).length;
        var sections = groupItemSections(product.menuItems);

        function renderOption(entry) {
          var item = entry.item;
          var selected = Object.prototype.hasOwnProperty.call(productChoices, String(item.id));
          var profile = assessmentProfileForItem(item);
          var classification = classificationForItem(item);
          var label = LABELS[classification.classification];
          return '<div class="byl-ppm__option' + (selected ? ' is-selected' : '') + '" data-variant-id="' + escapeHtml(item.id) + '">' +
            '<label class="byl-ppm__option-check"><input type="checkbox" data-option-toggle' + (selected ? ' checked' : '') + '><span aria-hidden="true">✓</span><strong>' + escapeHtml(entry.label) + '</strong></label>' +
            '<div class="byl-ppm__option-status"><span class="byl-ppm__badge" data-status="' + label.status + '">' + escapeHtml(label.text) + '</span><small>' + escapeHtml(optionDetails(profile, classification)) + '</small></div>' +
          '</div>';
        }

        var useSections = product.menuItems.length >= 6 || sections.length > 1;
        var optionsHtml = useSections ? sections.map(function (section) {
          var sectionExpanded = brandConfig.sectionState[section.key] !== false;
          var sectionSelected = section.entries.filter(function (entry) { return Object.prototype.hasOwnProperty.call(productChoices, String(entry.item.id)); }).length;
          return '<section class="byl-ppm__menu-section" data-section-key="' + escapeHtml(section.key) + '">' +
            '<button type="button" class="byl-ppm__section-toggle" data-section-toggle aria-expanded="' + (sectionExpanded ? 'true' : 'false') + '"><span>' + escapeHtml(section.title) + '</span><small>' + sectionSelected + ' of ' + section.entries.length + ' selected</small>' + chevron(sectionExpanded) + '</button>' +
            '<div class="byl-ppm__section-options"' + (sectionExpanded ? '' : ' hidden') + '>' + section.entries.map(renderOption).join('') + '</div>' +
          '</section>';
        }).join('') : product.menuItems.map(function (item) { return renderOption({ item: item, label: item.title }); }).join('');

        return '<article class="byl-ppm__brand-group" data-product-id="' + escapeHtml(product.id) + '">' +
          '<header><span class="byl-ppm__group-image">' + productVisual(product) + '</span><div class="byl-ppm__group-title"><h3>' + escapeHtml(product.title) + '</h3><p>' + selectedCount + ' of ' + product.menuItems.length + ' options selected</p></div>' +
          '<label class="byl-ppm__group-frequency"><span>Frequency</span><select data-group-frequency aria-label="Delivery frequency for ' + escapeHtml(product.title) + '">' + frequencyOptions(brandConfig.frequency) + '</select></label>' +
          '<button class="byl-ppm__group-toggle" type="button" data-group-toggle aria-expanded="' + (brandConfig.expanded ? 'true' : 'false') + '" aria-label="' + (brandConfig.expanded ? 'Collapse' : 'Expand') + ' ' + escapeHtml(product.title) + '">' + chevron(brandConfig.expanded) + '</button>' +
          '<button class="byl-ppm__group-remove" type="button" data-group-remove aria-label="Remove ' + escapeHtml(product.title) + '">×</button></header>' +
          '<div class="byl-ppm__options"' + (brandConfig.expanded ? '' : ' hidden') + '>' + optionsHtml + '</div>' +
        '</article>';
      }).join('');
      updateResults();
    }

    function selectedItems() {
      var items = [];
      Object.keys(choices).forEach(function (productId) {
        var product = findProduct(productId);
        var brandConfig = activeBrands[String(productId)];
        if (!product || !brandConfig) return;
        Object.keys(choices[productId]).forEach(function (variantId) {
          var item = findMenuItem(product, variantId);
          if (!item) return;
          var frequency = brandConfig.frequency;
          var profile = assessmentProfileForItem(item);
          var classification = classificationForItem(item);
          var balanced = !!(balancedNode && balancedNode.checked);
          var detail = optionDetails(profile, classification);
          if (balanced) detail = 'Balanced day: compares the full serving with a half serving at each nutrition break and keeps the better classification. ' + detail;
          items.push({
            brand: product.title,
            option: item.title,
            frequency: frequency,
            frequencyLabel: { daily: 'Daily', weekly: 'Weekly', biweekly: 'Bi-weekly', monthly: 'Monthly' }[frequency],
            type: choiceType(profile),
            classification: classification.classification,
            detail: detail,
            servingBasis: balanced ? '½ serving per break' : 'Full serving',
            weight: FREQUENCY[frequency] || 1
          });
        });
      });
      return items;
    }

    function updateBreakdown(type, bucket) {
      var node = element.querySelector('[data-ppm-breakdown="' + type + '"]');
      var statusNode = node.querySelector('[data-field="status"]');
      var statusText = { empty: 'No choices', pass: 'Pass', fail: 'Does not pass', review: 'Needs review' }[bucket.status];
      statusNode.textContent = statusText;
      statusNode.dataset.status = bucket.status;
      node.querySelector('[data-field="percent"]').textContent = Math.round(bucket.percent * 100) + '%';
      node.querySelector('[data-field="total"]').textContent = bucket.total;
      var guidance = type + ' is calculated separately from ' + (type === 'Food' ? 'beverages' : 'food') + '.';
      if (bucket.notPermitted) guidance = bucket.notPermitted + ' weighted offering' + (bucket.notPermitted === 1 ? '' : 's') + ' classified Not Permitted.';
      else if (bucket.review) guidance = bucket.review + ' weighted offering' + (bucket.review === 1 ? '' : 's') + ' still need nutrition data or review.';
      else if (bucket.status === 'fail' && bucket.addMost) guidance = 'Add at least ' + bucket.addMost + ' Sell Most offering' + (bucket.addMost === 1 ? '' : 's') + ' to reach an 80 / 20 mix.';
      else if (bucket.status === 'pass') guidance = 'This weighted mix meets the 80 / 20 threshold.';
      node.querySelector('[data-field="guidance"]').textContent = guidance;
    }

    function reportStatus(bucket) {
      return { empty: 'No choices', pass: 'Pass', fail: 'Does not pass', review: 'Needs review' }[bucket.status];
    }

    function updatePrintReport(items, summary, overallStatus, percent) {
      var report = element.querySelector('[data-ppm-print-report]');
      var balanced = !!(balancedNode && balancedNode.checked);
      var rowsHtml = items.length ? items.map(function (item) {
        return '<tr><td>' + escapeHtml(item.brand) + '</td><td>' + escapeHtml(item.option) + '</td><td>' + escapeHtml(item.frequencyLabel) + '</td><td>' + item.weight + '</td><td>' + escapeHtml(item.servingBasis) + '</td><td>' + escapeHtml(item.type) + '</td><td>' + escapeHtml(item.classification) + '</td></tr>';
      }).join('') : '<tr><td colspan="7">No menu options selected.</td></tr>';
      report.innerHTML = '<header><p>Boost Your Lunch</p><h1>PPM 150 Menu Mix</h1><span>' + escapeHtml(new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' })) + ' · ' + escapeHtml(schoolNode.value) + ' · ' + (balanced ? 'Balanced day (½ serving per break)' : 'Full serving') + '</span></header>' +
        '<section class="byl-ppm__print-summary"><div><span>Overall</span><strong>' + escapeHtml({ empty: 'No choices', pass: 'Pass', fail: 'Does not pass', review: 'Needs review' }[overallStatus]) + '</strong></div><div><span>Sell Most</span><strong>' + Math.round(percent * 100) + '%</strong></div><div><span>Food</span><strong>' + escapeHtml(reportStatus(summary.Food)) + '</strong></div><div><span>Beverages</span><strong>' + escapeHtml(reportStatus(summary.Beverage)) + '</strong></div></section>' +
        '<table><thead><tr><th>Brand</th><th>Menu option</th><th>Frequency</th><th>4-week offerings</th><th>Serving basis</th><th>Group</th><th>Classification</th></tr></thead><tbody>' + rowsHtml + '</tbody></table>' +
        '<section class="byl-ppm__print-breakdown"><h2>Breakdown</h2><p><strong>Food:</strong> ' + Math.round(summary.Food.percent * 100) + '% Sell Most across ' + summary.Food.total + ' weighted offerings — ' + escapeHtml(reportStatus(summary.Food)) + '.</p><p><strong>Beverages:</strong> ' + Math.round(summary.Beverage.percent * 100) + '% Sell Most across ' + summary.Beverage.total + ' weighted offerings — ' + escapeHtml(reportStatus(summary.Beverage)) + '.</p></section>' +
        '<footer>Planning estimate only. Confirm nutrition data and final compliance requirements before use.' + (balanced ? ' Balanced-day mode is a school-approved planning assumption. It compares full-serving and half-serving results, including half the container volume, and keeps the better classification.' : '') + '</footer>';
    }

    function updateResults() {
      var items = selectedItems();
      var summary = summarize(items);
      var total = summary.Food.total + summary.Beverage.total;
      var most = summary.Food.most + summary.Beverage.most;
      var less = summary.Food.less + summary.Beverage.less;
      var other = summary.Food.notPermitted + summary.Beverage.notPermitted + summary.Food.review + summary.Beverage.review;
      var percent = total ? most / total : 0;
      var statuses = [summary.Food, summary.Beverage].filter(function (bucket) { return bucket.total; }).map(function (bucket) { return bucket.status; });
      var overallStatus = !statuses.length ? 'empty' : statuses.indexOf('fail') >= 0 ? 'fail' : statuses.indexOf('review') >= 0 ? 'review' : 'pass';
      var overallNode = element.querySelector('[data-ppm-overall]');
      overallNode.dataset.status = overallStatus;
      overallNode.textContent = { empty: 'Add choices', pass: 'Plan passes', fail: 'Plan does not pass', review: 'Needs review' }[overallStatus];
      element.querySelector('[data-ppm-score-value]').textContent = Math.round(percent * 100) + '%';
      element.querySelector('[data-ppm-ring]').style.setProperty('--ppm-score', Math.round(percent * 100));
      element.querySelector('[data-ppm-most]').textContent = most;
      element.querySelector('[data-ppm-less]').textContent = less;
      element.querySelector('[data-ppm-other]').textContent = other;
      element.querySelector('[data-ppm-meter-most]').style.width = (total ? (most / total * 100) : 0) + '%';
      element.querySelector('[data-ppm-meter-less]').style.width = (total ? (less / total * 100) : 0) + '%';
      element.querySelector('[data-ppm-meter-other]').style.width = (total ? (other / total * 100) : 0) + '%';
      var message = 'Start by adding a restaurant option.';
      if (overallStatus === 'pass') message = 'The selected food and beverage groups meet the weighted 80 / 20 threshold.';
      if (overallStatus === 'review') message = 'One or more selected options need nutrition data before this plan can be assessed.';
      if (overallStatus === 'fail') message = 'At least one group misses the 80 / 20 threshold or includes a Not Permitted option.';
      if (balancedNode && balancedNode.checked) message += ' Balanced-day mode compares full-serving and half-serving results, including half the container volume, and keeps the better classification.';
      element.querySelector('[data-ppm-summary]').textContent = message;
      updateBreakdown('Food', summary.Food);
      updateBreakdown('Beverage', summary.Beverage);
      updatePrintReport(items, summary, overallStatus, percent);
    }

    brandSelect.addEventListener('change', function () {
      brandAdd.disabled = !brandSelect.value;
    });

    brandAdd.addEventListener('click', function () {
      var productId = String(brandSelect.value || '');
      if (!productId || activeBrands[productId]) return;
      activeBrands[productId] = { frequency: brandFrequency.value || 'weekly', expanded: true };
      choices[productId] = choices[productId] || {};
      renderBrands();
      renderGroups();
    });

    groupsNode.addEventListener('change', function (event) {
      var group = event.target.closest('[data-product-id]');
      if (!group) return;
      var productId = String(group.dataset.productId);
      if (event.target.matches('[data-group-frequency]')) {
        activeBrands[productId].frequency = event.target.value;
        updateResults();
        return;
      }
      var option = event.target.closest('[data-variant-id]');
      if (!option) return;
      var variantId = String(option.dataset.variantId);
      choices[productId] = choices[productId] || {};
      if (event.target.matches('[data-option-toggle]')) {
        if (event.target.checked) choices[productId][variantId] = true;
        else delete choices[productId][variantId];
      }
      renderGroups();
    });

    groupsNode.addEventListener('click', function (event) {
      var group = event.target.closest('[data-product-id]');
      if (!group) return;
      var productId = String(group.dataset.productId);
      var sectionButton = event.target.closest('[data-section-toggle]');
      if (sectionButton) {
        var section = sectionButton.closest('[data-section-key]');
        var key = String(section.dataset.sectionKey);
        activeBrands[productId].sectionState = activeBrands[productId].sectionState || {};
        activeBrands[productId].sectionState[key] = sectionButton.getAttribute('aria-expanded') !== 'true';
        renderGroups();
      } else if (event.target.closest('[data-group-toggle]')) {
        activeBrands[productId].expanded = !activeBrands[productId].expanded;
        renderGroups();
      } else if (event.target.closest('[data-group-remove]')) {
        delete activeBrands[productId];
        delete choices[productId];
        renderBrands();
        renderGroups();
      }
    });

    element.querySelector('[data-ppm-print]').addEventListener('click', function () { root.print(); });
    element.querySelector('[data-ppm-download]').addEventListener('click', function () {
      var items = selectedItems();
      var summary = summarize(items);
      function csv(value) { return '"' + String(value == null ? '' : value).replaceAll('"', '""') + '"'; }
      var lines = [
        ['PPM 150 Menu Mix'],
        ['School level', schoolNode.value],
        ['Balanced day', balancedNode && balancedNode.checked ? 'Yes — ½ serving per nutrition break' : 'No — full serving'],
        ['Food Sell Most %', Math.round(summary.Food.percent * 100) + '%'],
        ['Food status', reportStatus(summary.Food)],
        ['Beverage Sell Most %', Math.round(summary.Beverage.percent * 100) + '%'],
        ['Beverage status', reportStatus(summary.Beverage)],
        [],
        ['Brand', 'Menu option', 'Frequency', '4-week offerings', 'Serving basis', 'Group', 'Classification', 'Nutrition note']
      ];
      items.forEach(function (item) { lines.push([item.brand, item.option, item.frequencyLabel, item.weight, item.servingBasis, item.type, item.classification, item.detail]); });
      var blob = new Blob([lines.map(function (line) { return line.map(csv).join(','); }).join('\r\n')], { type: 'text/csv;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'ppm150-menu-mix-' + new Date().toISOString().slice(0, 10) + '.csv';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 0);
    });
    schoolNode.addEventListener('change', renderGroups);
    if (balancedNode) balancedNode.addEventListener('change', renderGroups);

    fetch(element.dataset.fallbackUrl, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : {}; })
      .then(function (data) { fallback = data || {}; renderBrands(); renderGroups(); })
      .catch(function () { renderBrands(); renderGroups(); });
    renderBrands();
    renderGroups();
  }

  root.BYLPPM150 = { classify: classify, classifyBalanced: classifyBalanced, summarize: summarize, scaleProfile: scaleProfile, frequency: FREQUENCY, cleanMenuTitle: cleanMenuTitle, groupMenuItems: groupMenuItems, groupItemSections: groupItemSections };
  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-ppm-builder]').forEach(initBuilder);
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
